import {RunningTimeStoppage, StoppageType} from '@hconnect/common/types'

import {RunningTimesStoppageCodesByType} from '../types'

export const getRunningTimeStoppageLabelProps = (
  stoppageCodes: RunningTimesStoppageCodesByType,
  runningTimeStoppage: RunningTimeStoppage,
  stoppageType: StoppageType
) => {
  const stoppage = stoppageCodes[stoppageType]?.find(
    ({code}) => code === runningTimeStoppage.stoppageCode
  )
  const stoppageDescription = stoppage?.description
  return {
    stoppageCode: runningTimeStoppage.stoppageCode,
    stoppageDescription
  }
}
